export var AVAILABLE_MAX_LINES = 3;
export var DEFAULT_VARIANT_ELEMENTS = {
  caption: "small",
  body: "p",
  sectionSubtitle: "h3",
  sectionTitle: "h2",
  pageTitle: "h1"
};
export var AVAILABLE_VARIANTS = ["$caption", "$body", "$sectionSubtitle", "$sectionTitle", "$pageTitle", "$display100", "$display200", "$display300", "$display400", "$display500", "$display600", "$display700", "$display800", "$display900"];